import { useCallback } from "react";

import styled from "styled-components";

import { useOtherNetworks } from "CrossFeatureComponents/MemberToolbar/API/queryHooks";
import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

import { ButtonWrapper } from "../../shared";

import { ButtonDisplay } from "./ButtonDisplay";
import { useIsActive } from "./stateHooks";

const UserButton = () => {
  const { setActiveContentKey } = useMemberToolbarStore();
  const { userButtonRef } = useMemberToobarContext();
  const isActive = useIsActive();

  // prefetch networks if this button is available
  useOtherNetworks();

  const handleClick = useCallback(
    (e) => {
      if (isActive) setActiveContentKey(contentKeys.nothing);
      else setActiveContentKey(contentKeys.user);
    },
    [isActive, setActiveContentKey]
  );

  return (
    <SButtonWrapper
      onClick={handleClick}
      data-cy="MemberToolbar_UserButton"
      DisplayComponent={ButtonDisplay}
      isActive={isActive}
      ref={userButtonRef}
    />
  );
};

const SButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  align-items: center;
  padding: 10px 0px;
`;

export { UserButton };
